import React, { lazy } from "react";

import { Switch, Route, Redirect } from "react-router-dom";

import ResourceBreadcrumbs from "../navigation/ResourceBreadcrumbs";

import * as routes from ".";

const ResourceSets = lazy(() => import("./../pages/ResourceSets/ResourceSets"));
const ResourceSet = lazy(() => import("./../pages/ResourceSet/ResourceSet"));
const ResourceGroup = lazy(() => import("./../pages/ResourceGroup/ResourceGroup"));
const Resource = lazy(() => import("../pages/Resource/Resource"));

const ResourceRoute = () => (
  <>
    <Switch>
      <Route exact path={"/"}>
        <Redirect to={routes.RESOURCES} />
      </Route>

      <Route exact path={routes.RESOURCE_ID}>
        <ResourceBreadcrumbs />
        <Resource />
      </Route>

      <Route exact path={routes.RESOURCE_GROUP_ID}>
        <ResourceBreadcrumbs />
        <ResourceGroup />
      </Route>

      <Route exact path={routes.RESOURCE_GROUP_ADD_RESOURCE}>
        <ResourceBreadcrumbs />
        <Resource />
      </Route>

      <Route exact path={routes.RESOURCE_SET_ID}>
        <ResourceBreadcrumbs />
        <ResourceSet />
      </Route>

      <Route exact path={routes.RESOURCE_SET}>
        <ResourceBreadcrumbs />
        <Redirect to={routes.RESOURCES} />
      </Route>

      <Route exact path={routes.RESOURCES}>
        <ResourceSets />
      </Route>
    </Switch>
  </>
);

export default ResourceRoute;
